import { render, staticRenderFns } from "./OutboxList.vue?vue&type=template&id=c2fbd176&scoped=true&"
import script from "./OutboxList.vue?vue&type=script&lang=js&"
export * from "./OutboxList.vue?vue&type=script&lang=js&"
import style0 from "./OutboxList.vue?vue&type=style&index=0&id=c2fbd176&lang=scss&scoped=true&"
import style1 from "./OutboxList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2fbd176",
  null
  
)

export default component.exports